export const CONSTANTS = {
  access_token_key: "access_token",
  refresh_token_key: "refresh_token",

  signInRoute: "/sign-in",
  authCallbackRoute: "/auth/callback",
  ERROR_MSG_KEYS: {
    1: 'not_authorized',
    2: 'login_failed_try_again',
  }
};
